import styled from "styled-components";

export const SubmitButton = styled.input`
  align-items: center;
  cursor: pointer;
  display: flex;
  justify-content: center;
  height: 44px;
  text-transform: uppercase;
  border-radius: 22px;
  font-weight: bold;
  letter-spacing: 1.6px;
  background-color: #bbdfe4;
  color: #0b233f;
  border: none;
  &:hover {
    box-shadow: 0 6px 7px 0 rgba(199, 199, 199, 1);
  }
`;

export const BaseButton = styled.button`
  align-items: center;
  background: white;
  cursor: pointer;
  display: flex;
  justify-content: center;
  padding: 0 16px;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
    0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
  &:hover {
    box-shadow: 0 6px 7px 0 rgba(199, 199, 199, 1);
  }
  &:disabled {
    background: #ddd;
    box-shadow: none;
  }
`;

export const BorderButton = styled(BaseButton)`
  border-radius: 4px;
  box-shadow: 0 6px 10px 0 rgba(199, 199, 199, 0.5);
  border: 2px solid;
  border-color: #efefef;
  font-size: 1.125rem;
  font-weight: bold;
  height: 36px;
  letter-spacing: 1.8px;
  padding: 0 12px;
`;

export const Button = styled(BaseButton)`
  height: 44px;
  text-transform: uppercase;
  border-radius: 22px;
  font-weight: bold;
  letter-spacing: 1.6px;
  text-align: center;
`;

export const ButtonOk = styled(Button)`
  background-color: #bbdfe4;
  color: #0b233f;
`;

export const ButtonCancel = styled(Button)`
  background-color: white;
  border: 1px solid red;
  color: red;
`;



// WEBPACK FOOTER //
// ./src/styles/button.js